import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { Sheet } from "@/ui/Sheet/Sheet";
import { CheckIcon, GeoIcon, PinIcon } from "@/assets/icons";
import { CITIES, CITY_ORDER, CityKey } from "@/features/services";
import { distanceLabel } from "@/features/geo";
import { useGeoCity } from "@/features/useGeoCity";
import { useProfileStore } from "@/store/profile";
import cls from "./CitySheet.module.scss";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const CitySheet: React.FC<Props> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const city = useProfileStore((s) => s.city);
  const setCity = useProfileStore((s) => s.setCity);
  const [query, setQuery] = useState("");
  const geo = useGeoCity();

  const pick = (key: CityKey) => {
    setCity(key);
    onClose();
  };

  const q = query.trim().toLowerCase();
  const list = CITY_ORDER.filter((k) => !q || CITIES[k].name.toLowerCase().includes(q));

  return (
    <Sheet isOpen={isOpen} onClose={onClose} title={t("sheet.city")}>
      <input
        className={cls.search}
        placeholder={t("sheet.citySearch")}
        value={query}
        autoComplete="off"
        onChange={(e) => setQuery(e.target.value)}
      />

      {geo.status === "ready" && geo.result ? (
        <button type="button" className={cls.geonow} onClick={() => pick(geo.result!.city)}>
          <PinIcon />
          <span>
            {t("sheet.geoNow")} <b>{CITIES[geo.result.city].name}</b>
            <small>{distanceLabel(geo.result.distanceKm)}</small>
          </span>
          <em>{city === geo.result.city ? t("sheet.geoChosen") : t("sheet.geoChoose")}</em>
        </button>
      ) : (
        <button
          type="button"
          className={classNames(cls.geobtn, geo.status === "busy" && cls.busy)}
          onClick={geo.detect}
          disabled={geo.status === "busy"}
        >
          <GeoIcon />
          {geo.status === "busy" ? t("sheet.geoBusy") : t("sheet.geoDetect")}
        </button>
      )}
      {geo.status === "error" && geo.error && (
        <div className={cls.geoError}>
          {geo.error}. {t("sheet.geoManual")}
        </div>
      )}

      {list.length ? (
        list.map((k) => (
          <button
            key={k}
            type="button"
            className={classNames(cls.li, k === city && cls.on)}
            onClick={() => pick(k)}
          >
            <span className={cls.ttl}>{CITIES[k].name}</span>
            {k === city && (
              <span className={cls.chev}>
                <CheckIcon />
              </span>
            )}
          </button>
        ))
      ) : (
        <div className={cls.empty}>{t("sheet.cityNotFound")}</div>
      )}
    </Sheet>
  );
};
